import { useIntl } from 'react-intl';

import {CartActionType, CartProduct, useCartDispatch} from 'public/context/CartContext';
import AmountSelector from 'ui/CartAmountSelector/CartAmountSelector';
import { Icon } from 'ui/Icon';
import { FallbackImage } from 'ui/UploadImage/fallBack/FallBackImage';
import { ProductUnityPrice } from 'utils/productCardHelpers';
import { CartProductPrice } from 'utils/productTotalPriceHelper';

import { StyledCartCard } from './style';

export interface CartCardProps {
  product: CartProduct;
  isView?: boolean | undefined;
}

export const CartCard = ({ product, isView }: CartCardProps) => {
  const intl = useIntl();
  const cartDispatch = useCartDispatch();

  return (
    <StyledCartCard className="cart-product">
      <div className={'cart-products-content'}>
        <div className={'cart-cell-1'}>
          {!isView && <Icon
            onClick={() => product?.cartProduct && cartDispatch({
                type: CartActionType.REMOVE_ITEM,
                productId: product.cartProduct.id,
                farmId: product.cartProduct.farm_id,
              })
            }
            name={'cart-product-colse-button'}
            className={'cart-products-remove-button'}
          />}
          <FallbackImage
            src={product.cartProduct?.image_small || ''}
            type={'ProductCard'}
          />
        </div>
        <div className={'cart-cell-2'}>
          <p className={'cart-product-farm-name'}>
            {product.cartProduct?.farm_name}
          </p>
          <p className={'cart-product-name'}>{product.cartProduct?.name} </p>
        </div>
        <div className={'cart-cell-3'}>
          <div className={'price-container'}>
            <ProductUnityPrice product={product.cartProduct} />
            <CartProductPrice
              product={product}
              type={'PER_UNIT'}
            />
          </div>
        </div>
        <div className={'cart-cell-4'}>
          {isView ? (
            <div className={'cart-product-amount-view'}>
              {'x' + product.amount}
            </div>
          ) : (
            <AmountSelector
              amountCart={product.amount}
              product={product.cartProduct}
              unitType={product.cartProduct?.storage_unit}
            />
          )}
        </div>
        <div className={'cart-cell-5'}>
          <div className={'price-container'}>
            <CartProductPrice
              product={product}
              type={'TOTAL'}
            />
          </div>
        </div>
      </div>

      <div className="mobile-cart-cells">
        <div className={'cart-cell-4'}>
          <AmountSelector
            amountCart={product.amount}
            product={product.cartProduct}
            unitType={product.cartProduct?.storage_unit}
          />
        </div>

        <div className={'cart-cell-5'}>
          <span className="label">{intl.formatMessage({ id: 'orders.summary' }) + ': '}</span>
          <div className={'price-container'}>  
            <CartProductPrice
              product={product}
              type={'TOTAL'}
            />
          </div>
        </div>
      </div>
    </StyledCartCard>
  );
};
